import React from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCButton from '../../../../components/Simple/SMCButton';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import Api from '../../../../api/SMPFetchHelper';
import {getErrorCode, enqueueFileDownload, getAxiosFilename} from '../../../../utils/utils';
import {useSMCSnackbar} from '../../../../utils/hooks';
import {ApiErrorCodes} from '../../../../api/consts';

function PortalSettingsCertificate() {
    const { t } = useTranslation();
    const { enqueueErrorSnackbar } = useSMCSnackbar();
    return (
        <EditorLayout>
            <SMCLabel bold>{t('SMP.SETTINGS.CERTIFICATES.LINE1')}</SMCLabel>
            <SMCButton
                onClick={() => {
                    Api.getCaCert()
                    .then(resp => {
                        const fileName = getAxiosFilename(resp) || 'smp.crt';
                        enqueueFileDownload(resp.data, fileName);
                    })
                    .catch(err => {
                        const errorCode = getErrorCode(err) || ApiErrorCodes.GENERAL_ERROR;
                        enqueueErrorSnackbar(t(errorCode));
                    })
                }}
            >
                {t('SMC_SETTINGS_CERT_EXP_CA')}
            </SMCButton>
        </EditorLayout>
    )
}

export default PortalSettingsCertificate;